import { module as Module } from 'modujs'

export default class extends Module {
    constructor(m) {
        super(m)

        this.$content = this.$('content')[0]
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.removeExtremeMargins()
        this.addScrollAnim()
    }

    destroy() {
        super.destroy()
    }

    addScrollAnim() {
        if(!this.$content) return;

        [...this.$content.children].forEach( (children, i) => {
            children.setAttribute("data-scroll", true)
            children.classList.add("u-anim-scroll");
        })

        this.call('addScrollElements', this.$content, 'Scroll');
    }

    ///////////////
    // Methods
    ///////////////
    removeExtremeMargins() {
        if (this.$content) {
            if (this.$content.children.length) {
                const $firstElement = this.$content.children[0]
                const $lastElement =
                    this.$content.children[this.$content.children.length - 1]
                $firstElement.classList.add('c-wysiwyg_first')
                $lastElement.classList.add('c-wysiwyg_last')
            }
        }
    }
}
